import { type EMRKindID, type EMRTypeID } from './_EMR.ts'

export const GAHTTermination_ID = 'imago.gaht.gaht-termination' as EMRTypeID & EMRKindID
